import React, { Fragment, useEffect, useState } from 'react'
import Header from './Header'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import Footer from './Footer'
import LandingFooter from './LandingFooter'
import HomeFooter from '../home/Footer'
import { getFromStorage } from '../../utils/Helper'
import { StorageConstant } from '../../constants/Constants'
import NotificationPopup from '../notification/NotificationPopup'
import SocialProfileGate from './SocialProfileGate'

function Layout() {
  const { pathname, state: locationState } = useLocation()
  const navigate = useNavigate()
  const [notificationOpen, setNotificationOpen] = useState(false)
  const isMarketingLanding = pathname === '/' || pathname === ''
  const isCmsPage = pathname.startsWith('/cms/')
  const isFaqPage = pathname === '/faq' || pathname.endsWith('/faq')
  const isAddressPage = pathname.startsWith('/address')
  const useHomeFooter =
    isAddressPage ||
    pathname.endsWith('/profile')
  const useLandingFooter =
    pathname.endsWith('/category') ||
    pathname.endsWith('/update-category')
  const useHomeStyleFooter =
    pathname.endsWith('/category') || pathname.endsWith('/update-category')
  const hasAccessToken = Boolean(getFromStorage({ key: StorageConstant?.ACCESS_TOKEN }))
  const showHeader =
    (!isMarketingLanding || (isMarketingLanding && hasAccessToken)) &&
    !(isCmsPage && !hasAccessToken) &&
    !(isFaqPage && !hasAccessToken)

  useEffect(() => {
    const navState = locationState as { openNotifications?: boolean } | null
    if (navState?.openNotifications) {
      setNotificationOpen(true)
      navigate(pathname, { replace: true, state: {} })
    }
  }, [locationState, pathname, navigate])

  useEffect(() => {
    const onOpen = () => setNotificationOpen(true)
    window.addEventListener('notification:open', onOpen)
    return () => window.removeEventListener('notification:open', onOpen)
  }, [])

  /** Keep notification list/timestamps fresh while the user stays on the page. */
  useEffect(() => {
    if (!hasAccessToken) return
    const refreshNotifications = () => {
      window.dispatchEvent(new CustomEvent('notification:refresh'))
    }
    refreshNotifications()
    const pollId = window.setInterval(refreshNotifications, 120_000)
    const onVisible = () => {
      if (document.visibilityState === 'visible') refreshNotifications()
    }
    document.addEventListener('visibilitychange', onVisible)
    return () => {
      window.clearInterval(pollId)
      document.removeEventListener('visibilitychange', onVisible)
    }
  }, [hasAccessToken])

  /** Bell still links to `/notification` in Header — open popup without leaving the page. */
  useEffect(() => {
    const onCaptureClick = (event: MouseEvent) => {
      const target = event.target as HTMLElement | null
      if (!target) return
      const bell = target.closest('a.head-notify, button.head-notify')
      if (!bell) return
      const href = bell instanceof HTMLAnchorElement ? bell.getAttribute('href') : null
      if (href && !href.includes('notification')) return
      if (bell instanceof HTMLButtonElement || href) {
        event.preventDefault()
        event.stopPropagation()
        setNotificationOpen(true)
      }
    }
    document.addEventListener('click', onCaptureClick, true)
    return () => document.removeEventListener('click', onCaptureClick, true)
  }, [])

  return (
  <>
      <SocialProfileGate />
   <Fragment>
            <div
              id="layout-wrapper"
              className={useLandingFooter ? 'layout-wrapper--natural' : undefined}
            >
                {showHeader ? <Header /> : null}
                <Outlet />
            </div>
            {!isMarketingLanding &&
              !isCmsPage &&
              !isFaqPage &&
              (useHomeStyleFooter
                ? <HomeFooter />
                : (useLandingFooter ? <LandingFooter /> : <Footer />))}
        </Fragment>
      <NotificationPopup show={notificationOpen} onHide={() => setNotificationOpen(false)} />
  </>
  )
}

export default Layout
